import * as React from "react";
function SvgIcCancel(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.97 1.97a.75.75 0 111.06 1.06L8.06 7l3.97 3.97a.75.75 0 11-1.06 1.06L7 8.06l-3.97 3.97a.75.75 0 01-1.06-1.06L5.94 7 1.97 3.03a.75.75 0 011.06-1.06L7 5.94l3.97-3.97z" fill="currentColor" /></svg>;
}
export default SvgIcCancel;